import { render } from "./EcommerceLayout.vue?vue&type=template&id=10d60dc2"
import script from "./EcommerceLayout.vue?vue&type=script&lang=js"
export * from "./EcommerceLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__